import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "../../../environments/environment";
import { BCLedgerTotalRequestDto } from "../models/bcLedger/bcLedgerTotalRequestDto";
import { BCLedgerTotalResponseDto } from "../models/bcLedger/bcLedgerTotalResponseDto";
import { CommissionProgramTierRequestDto } from "../models/bcLedger/commissionProgramTierRequestDto";
import { CommissionProgramTierResponseDto } from "../models/bcLedger/commissionProgramTierResponseDto";
import { YtdSummaryRequestDto } from "../models/bcLedger/ytdSummaryRequestDto";
import { YtdSummaryResponseDto } from "../models/bcLedger/ytdSummaryResponseDto";
import { GenericResponseDto } from "../models/generic-response.dto";
import { Employee } from "../models/profile/employee";
import { BcRevenueTransactionsResponseDto } from "../models/bcLedger/BcRevenueTransactionsResponseDto";
import { ChargeBackRequestDto } from "../models/bcLedger/chargeBackRequestDto";
import { AdjustmentsRequestDto } from "../models/bcLedger/adjustmentsRequestDto";
import { CommissionPaidTotalRequestDto } from "../models/bcLedger/commissionPaidTotalRequestDto";
import { CommissionPaidTotalResponseDto } from "../models/bcLedger/commissionPaidTotalResponseDto";
import { YtdBacklogRequest } from "../models/bcLedger/ytdbacklog/YtdBacklogRequest";
import { YtdBacklogResponse } from "../models/bcLedger/ytdbacklog/YtdBacklogResponse";
import { FreightsRequestDto } from "../models/bcLedger/freightsRequestDto";
import { FreightsResponseDto } from "../models/bcLedger/freightsResponseDto";
import { GetSalesOrderIdRequestDto } from "../models/bcLedger/getSalesOrderIdRequestDto";
import { GetSalesOrderIdResponseDto } from "../models/bcLedger/getSalesOrderIdResponseDto";
import { GetTrackingDetailsRequestDto } from "../models/bcLedger/getTrackingDetailsRequestDto";
import { GetTrackingDetailsResponseDto } from "../models/bcLedger/getTrackingDetailsResponseDto";
import { GPAdjustmentRequestDto } from "../models/bcLedger/gpAdjustmentRequestDto";
import { GPAdjustmentResponseDto } from "../models/bcLedger/gpAdjustmentResponseDto";
import { MiscRequestDto } from "../models/bcLedger/misc/MiscRequestDto";
import { MiscResponseDto } from "../models/bcLedger/misc/MiscResponseDto";
import { MoveToFreightRequestDto } from "../models/bcLedger/moveToFreightRequestDto";
import { MoveToFreightResponseDto } from "../models/bcLedger/moveToFreightResponseDto";
import { NetChargesRequestDto } from "../models/bcLedger/netChargesRequestDto";
import { SalesCommissionRequestDto } from "../models/bcLedger/salesCommissionRequestDto";
import { SampleRequestDto } from "../models/bcLedger/sample/SampleRequestDto";
import { SampleResponseDto } from "../models/bcLedger/sample/SampleResponseDto";
import { TotalApMiscRequestDto } from "../models/bcLedger/totalApMiscRequestDto";
import { TotalApMiscResponseDto } from "../models/bcLedger/totalApMiscResponseDto";
import { YtdgpRequestDto } from "../models/bcLedger/ytdgpRequestDto";
import { TypeDto } from "../models/bcLedger/typeDto";

@Injectable({
  providedIn: "root",
})
export class BcledgerService {
  private clientManagementBaseURL = environment.baseUrl + "/ClientManagement";
  private bcLedgerBaseURL = environment.baseUrl + "/bcledger";
  private commonBaseURL = environment.baseUrl + "/Common";
  constructor(private _http: HttpClient) {}

  getTypeList(): Observable<GenericResponseDto<TypeDto[]>> {
    return this._http.get<GenericResponseDto<TypeDto[]>>(
      this.clientManagementBaseURL + "/GetAllClientType"
    );
  }

  bcLedgerTotal(
    payload: BCLedgerTotalRequestDto
  ): Observable<GenericResponseDto<BCLedgerTotalResponseDto>> {
    return this._http.post<GenericResponseDto<BCLedgerTotalResponseDto>>(
      `${this.bcLedgerBaseURL}/BCLedgerTotal`,
      payload
    );
  }

  ytdSummary(
    payload: YtdSummaryRequestDto
  ): Observable<GenericResponseDto<YtdSummaryResponseDto>> {
    return this._http.post<GenericResponseDto<YtdSummaryResponseDto>>(
      `${this.bcLedgerBaseURL}/YtdSummary`,
      payload
    );
  }

  commissionProgramTier(
    payload: CommissionProgramTierRequestDto
  ): Observable<GenericResponseDto<CommissionProgramTierResponseDto>> {
    return this._http.post<
      GenericResponseDto<CommissionProgramTierResponseDto>
    >(`${this.bcLedgerBaseURL}/CommissionProgramTier`, payload);
  }

  getAllEmployees(): Observable<GenericResponseDto<Employee[]>> {
    return this._http.get<GenericResponseDto<Employee[]>>(
      `${this.commonBaseURL}/GetAllEmployees`
    );
  }

  getAllEmployeesForOrderBillingReport(): Observable<
    GenericResponseDto<Employee[]>
  > {
    return this._http.get<GenericResponseDto<Employee[]>>(
      `${this.commonBaseURL}/GetAllEmployeesForOrderBillingReport`
    );
  }

  chargeBack(
    payload: ChargeBackRequestDto
  ): Observable<GenericResponseDto<BcRevenueTransactionsResponseDto>> {
    return this._http.post<
      GenericResponseDto<BcRevenueTransactionsResponseDto>
    >(`${this.bcLedgerBaseURL}/ChargeBack`, payload);
  }

  getBacklogDetailsData(
    payload: YtdBacklogRequest
  ): Observable<GenericResponseDto<YtdBacklogResponse>> {
    return this._http.post<GenericResponseDto<YtdBacklogResponse>>(
      `${this.bcLedgerBaseURL}/YTDBacklog`,
      payload
    );
  }

  adjustments(
    payload: AdjustmentsRequestDto
  ): Observable<GenericResponseDto<BcRevenueTransactionsResponseDto>> {
    return this._http.post<
      GenericResponseDto<BcRevenueTransactionsResponseDto>
    >(`${this.bcLedgerBaseURL}/Adjustments`, payload);
  }

  commissionPaidTotal(
    payload: CommissionPaidTotalRequestDto
  ): Observable<GenericResponseDto<CommissionPaidTotalResponseDto>> {
    return this._http.post<GenericResponseDto<CommissionPaidTotalResponseDto>>(
      `${this.bcLedgerBaseURL}/CommissionPaidTotal`,
      payload
    );
  }

  getTrackingDetailData(
    payload: GetTrackingDetailsRequestDto
  ): Observable<GenericResponseDto<GetTrackingDetailsResponseDto>> {
    return this._http.post<GenericResponseDto<GetTrackingDetailsResponseDto>>(
      `${this.bcLedgerBaseURL}/GetTrackingDetails`,
      payload
    );
  }

  freights(
    payload: FreightsRequestDto
  ): Observable<GenericResponseDto<FreightsResponseDto>> {
    return this._http.post<GenericResponseDto<FreightsResponseDto>>(
      `${this.bcLedgerBaseURL}/Freights`,
      payload
    );
  }

  gpAdjustments(
    payload: GPAdjustmentRequestDto
  ): Observable<GenericResponseDto<GPAdjustmentResponseDto>> {
    return this._http.post<GenericResponseDto<GPAdjustmentResponseDto>>(
      `${this.bcLedgerBaseURL}/GPAdjustment`,
      payload
    );
  }

  getMiscData(
    payload: MiscRequestDto
  ): Observable<GenericResponseDto<MiscResponseDto>> {
    return this._http.post<GenericResponseDto<MiscResponseDto>>(
      `${this.bcLedgerBaseURL}/Misc`,
      payload
    );
  }

  getSalesOrderID(
    payload: GetSalesOrderIdRequestDto
  ): Observable<GenericResponseDto<GetSalesOrderIdResponseDto>> {
    return this._http.post<GenericResponseDto<GetSalesOrderIdResponseDto>>(
      `${this.bcLedgerBaseURL}/GetSalesOrderID`,
      payload
    );
  }

  moveToFreight(
    payload: MoveToFreightRequestDto
  ): Observable<GenericResponseDto<MoveToFreightResponseDto>> {
    return this._http.post<GenericResponseDto<MoveToFreightResponseDto>>(
      `${this.bcLedgerBaseURL}/MoveToFreight`,
      payload
    );
  }

  netCharges(
    payload: NetChargesRequestDto
  ): Observable<GenericResponseDto<BcRevenueTransactionsResponseDto>> {
    return this._http.post<
      GenericResponseDto<BcRevenueTransactionsResponseDto>
    >(`${this.bcLedgerBaseURL}/NetCharges`, payload);
  }

  salesCommission(
    payload: SalesCommissionRequestDto
  ): Observable<GenericResponseDto<BcRevenueTransactionsResponseDto>> {
    return this._http.post<
      GenericResponseDto<BcRevenueTransactionsResponseDto>
    >(`${this.bcLedgerBaseURL}/SalesCommission`, payload);
  }

  getSampleData(
    payload: SampleRequestDto
  ): Observable<GenericResponseDto<SampleResponseDto>> {
    return this._http.post<GenericResponseDto<SampleResponseDto>>(
      `${this.bcLedgerBaseURL}/Sample`,
      payload
    );
  }

  getTotalApMisc(
    payload: TotalApMiscRequestDto
  ): Observable<GenericResponseDto<TotalApMiscResponseDto>> {
    return this._http.post<GenericResponseDto<TotalApMiscResponseDto>>(
      `${this.bcLedgerBaseURL}/TotalApMisc`,
      payload
    );
  }

  totalSalesCommissionsAdjustments(
    payload: SalesCommissionRequestDto
  ): Observable<GenericResponseDto<BcRevenueTransactionsResponseDto>> {
    return this._http.post<
      GenericResponseDto<BcRevenueTransactionsResponseDto>
    >(`${this.bcLedgerBaseURL}/TotalSalesCommissionsAdjustments`, payload);
  }

  ytdgp(
    payload: YtdgpRequestDto
  ): Observable<GenericResponseDto<BcRevenueTransactionsResponseDto>> {
    return this._http.post<
      GenericResponseDto<BcRevenueTransactionsResponseDto>
    >(`${this.bcLedgerBaseURL}/YTDGP`, payload);
  }
}
